export default __webpack_public_path__ + "static/media/download001.6e45fb1a.jpg";